"use strict";

exports.__esModule = true;
var _LazyImage = _interopRequireDefault(require("./LazyImage"));
exports.default = _LazyImage.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}